import { merge } from "lodash";
import addressModuleState from "./addressModule/state";
import shipmentModuleState from "./shipmentModule/state";

export default merge(addressModuleState, shipmentModuleState);
